import { Flex, Stack, Switch, Text } from '@mantine/core';
import { FormattedMessage } from 'react-intl';

import { LoadingIndicator } from 'ui-components/components/loading-indicator';

import { useEnhancedModeActivation } from '../../../hooks/use-enhanced-mode-activation';
import type { RetailerConfig } from '../../../hooks/use-enhanced-mode-activation';

import styles from './styles.module.less';
import { messages } from './messages';

type ReturnModeToggleProps = {
  retailerConfig: RetailerConfig;
  storeGuid: string;
};

export const ReturnModeToggle = ({ retailerConfig, storeGuid }: ReturnModeToggleProps) => {
  const { isEnhancedModeEnabled, isEnhancedModeToggleDisabled, isActivatingStore, onToggleEnhancedMode } = useEnhancedModeActivation(
    storeGuid,
    retailerConfig,
  );

  const isAdvanceModeSupported = retailerConfig?.storeProperties?.is_enhanced_supported ?? false;

  if (!isAdvanceModeSupported) return null;

  return (
    <Flex align='flex-start' gap='xs' justify='space-between'>
      <Stack gap={0}>
        <Text size='sm'>
          <FormattedMessage {...messages.allowRefundsTitle} />
        </Text>
        <Text c='gray' size='xs'>
          <FormattedMessage {...messages.allowRefundsDescription} />
        </Text>
      </Stack>
      <Flex align='center' gap='xs'>
        {isActivatingStore && <LoadingIndicator className={styles.loadingSpinner} />}
        <Switch
          checked={isEnhancedModeEnabled}
          disabled={isEnhancedModeToggleDisabled || isActivatingStore}
          onChange={onToggleEnhancedMode}
        />
      </Flex>
    </Flex>
  );
};
